// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"xH","carousel__wrapper_on_sides":"yH","arrows_wrapper":"zH","arrows_wrapper_right":"AH","arrows_wrapper_vertical":"BH","arrows_wrapper_on_sides":"CH","arrow_button":"EH","carousel_arrow_left":"FH","carousel_arrow_left_on_side":"GH","carousel_arrow_right_on_side":"HH","carousel_arrow":"IH","arrows_wrapper_rounded":"JH","carousel__fullWidth":"KH"};
    if(module.hot) {
      // 1737143662117
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  